<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="row">
            <div class="col-12 text-center">
                หมวดหมู่สินค้าเฉพาะ
            </div>
            <div class="col-4 mt-3 text-right">
                ชื่อหมวดหมู่
            </div>
            <div class="col-6 mt-3">
                <input class="form-control" v-model="form.name"/>
            </div>
            <div class="col-4 mt-3 text-right">
                ค้นหา
            </div>
            <div class="col-3 mt-3">
                <multiselect
                    style="height: 100%"
                    v-model="search.product"
                    class="border-0"
                    :options="optionProducts"
                    :customLabel="LabelSkuWithName"
                    placeholder="ค้นหาสินค้า"
                    :show-labels="false"
                    :close-on-select="false"
                    multiple
                    :searchable="true"
                    track-by="id">
                </multiselect>
                &nbsp
            </div>
            <!--            <div class="col-3 mt-3">-->
            <!--                <multiselect-->
            <!--                    :show-labels="false"-->
            <!--                    placeholder="หมวดหมู่สินค้า"-->
            <!--                    track-by="id">-->
            <!--                </multiselect>-->
            <!--            </div>-->
            <div class="col-2 pt-3">
                <button type="button" class="btn btn-info" @click="Search">
                    <icon name="search"></icon>
                    ค้นหา
                </button>
            </div>
            <div style="width: 100%;padding: 0 20% 0 20%">
                <table class="table-bordered" style="width: 100%">
                    <tr>
                        <th></th>
                        <th>sku</th>
                        <th>ชื่อสินค้า</th>
                        <th>หมวดหมู่เดิม</th>
                    </tr>
                    <tr v-for="x in productlist">
                        <td>
                            <input type="checkbox" v-model="checked"
                                   :value="x.id"/>
                        </td>
                        <td>{{ x.sku }}</td>
                        <td>{{ x.name }}</td>
                        <td>
                            <template v-if="x.product_type_special">{{ x.product_type_special.name }}</template>
                        </td>
                    </tr>
                </table>
                <div v-if="productlist.length > 0">
                    <vue-pagination :pagination="dataPaginate"
                                    @paginate="getSpecial">
                    </vue-pagination>
                </div>
            </div>
            <div class="col text-center">
                <button type="button" class="btn btn-success" @click="submitData">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก
                </button>
                &nbsp;&nbsp;
                <button class="btn btn-outline-secondary" @click="cancelData">
                    <icon name="times" style="width: 25px"></icon>
                    ยกเลิก
                </button>
                &nbsp;&nbsp;
            </div>
        </div>
    </div>

</template>

<script>
import {mapState} from "vuex"
import Multiselect from "vue-multiselect"
import DatePicker from 'vue2-datepicker'
import VuePagination from "../../Pagination";

export default {
    name: "products-type-info",
    props: ['id'],
    components: {
        Multiselect, DatePicker, VuePagination
    },
    created() {
        if (this.id != 'create') {
            this.$store.dispatch('Products/showSpecial', this.id).then(res => {
                //console.log(res)
                this.form.name = res.data.name
                res.checked.forEach(x => {
                    this.checked.push(x.id)
                })

                this.getPage(1)
            })
        } else {
            this.getPage(1)
        }
    },
    data() {
        return {
            items: [
                {
                    text: "หมวดสินค้า(เฉพาะ)",
                    to: {name: "products-type"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            checked: [],
            form: {
                checked: [],
                name: ''
            },
            search: {
                product: '',
                type: ''
            }
        };
    },
    computed: {
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            productlist: state => {
                return state.Products.product_all_special
            },
            dataPaginate: state => {
                return state.Products.specialPaginate
            },
            optionProducts: state => {
                return state.ProductType.product;
            },
        }),
    },
    methods: {
        LabelSkuWithName(option) {
            if (this.optionProducts.length > 0) {
                return `${option.sku} - ${option.name}`
            }
        },
        getSpecial() {
            this.getPage(this.dataPaginate.current_page)
        },
        getPage(page) {
            let data = {
                'product': '',
                'type': ''
            }
            this.$store.dispatch('Products/getProductAllSpecial', {'page': page, 'data': data}).then(() => {
            })
        },
        Search() {
            let id = '';
            if (this.search.product.length > 0) {
                this.search.product.forEach((x, i) => {
                    i == this.search.product.length - 1 ? id += x.id : id += x.id + ',';
                })
            }
            let data = {
                'product': id,
                'type': ''
            }
            this.$store.dispatch('Products/getProductAllSpecial', {'page': 1, 'data': data})
        },
        submitData() {
            let data = {
                'id': this.id == 'create' ? null : this.id,
                'name': this.form.name,
                'checked': this.checked
            }
            this.$store.dispatch('Products/saveSpecial', data).then(() => {
                this.$router.push({name: 'products-type'})
            })
        },
        cancelData() {
            this.$router.push({name: 'products-type'})
        }
    }
}
</script>

<style scoped>

</style>
